export const levelColors = {
  'A1': 'primary',
  'A2': 'success',
  'B1': 'info',
  'B2': 'warning',
  'C1': 'secondary',
  'C2': 'error',
};

export const typeColors = {
  'full-test': 'primary',
  'listening': 'info',
  'reading': 'success',
  'speaking': 'warning',
  'writing': 'secondary',
};

export const SECTION = {
  LISTENING: 'listening',
  READING: 'reading',
};

// Page size used when loading classes from GET /admin/classes
export const CLASSES_PAGE_SIZE = 10;
